var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from 'react';
import { Route } from "react-router-dom";
import Page401 from "./Page401";
import { useSelector } from "react-redux";

var PrivateRoute = function PrivateRoute(_ref) {
    var _ref$render = _ref.render,
        _render = _ref$render === undefined ? null : _ref$render,
        _ref$component = _ref.component,
        component = _ref$component === undefined ? null : _ref$component,
        _ref$children = _ref.children,
        children = _ref$children === undefined ? null : _ref$children,
        _ref$allowAll = _ref.allowAll,
        allowAll = _ref$allowAll === undefined ? false : _ref$allowAll,
        rest = _objectWithoutProperties(_ref, ["render", "component", "children", "allowAll"]);

    var loggedIn = useSelector(function (state) {
        return state.header.auths.loggedIn;
    });

    var _useSelector = useSelector(function (state) {
        return state.header.authz;
    }),
        canAccessApp = _useSelector.canAccessApp;

    if (!canAccessApp && !allowAll) {
        return null;
    }

    var childrenOr401 = function childrenOr401() {
        return loggedIn ? children : React.createElement(Page401, null);
    };

    var componentOr401 = function componentOr401() {
        return loggedIn ? component : Page401;
    };

    if (children) {
        return React.createElement(
            Route,
            rest,
            childrenOr401()
        );
    }

    if (component) {
        return React.createElement(Route, _extends({}, rest, { component: componentOr401() }));
    }

    if (_render) {
        return React.createElement(Route, _extends({}, rest, {
            render: function render(props) {
                return loggedIn === true ? _render(_extends({}, props)) : React.createElement(Page401, null);
            }
        }));
    }
};

export default PrivateRoute;